import React from 'react';
import { ReactComponent as DivirodLogo } from './logos/divirod.svg';

import { ReactComponent as InstagramLogo } from './logos/instagram.svg';
import { ReactComponent as LinkedInLogo } from './logos/linkedin.svg';
import { ReactComponent as YouTubeLogo } from './logos/youtube.svg';

function SocialLink({ url, Icon }) {
  return (
    <a
      style={{ height: '24px', margin: '0 1px' }}
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label={url}
    >
      <Icon style={{ height: '24px', fill: 'var(--gray0)' }} />
    </a>
  );
}

export default function LogoPanel() {
  return (
    <div className="logo-panel">
      <a
        className="frosted"
        aria-label="Divirod Website"
        href="https://divirod.com"
        target="_blank"
        rel="noreferrer"
        style={{ marginBottom: '4px', padding: '8px', height: '40px' }}
      >
        <DivirodLogo style={{ height: '40px' }} />
      </a>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          className="frosted"
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            flex: 1,
            height: '32px'
          }}
        >
          <SocialLink url="https://www.instagram.com/divirod_inc" Icon={InstagramLogo} />
          <SocialLink url="https://www.linkedin.com/company/divirod" Icon={LinkedInLogo} />
          <SocialLink url="https://www.youtube.com/channel/UC4NdnLAXmUWpR37w3b_g3PA" Icon={YouTubeLogo} />
        </div>
        <a
          className="frosted"
          style={{
            color: 'var(--gray1)',
            fontSize: '12px',
            marginLeft: '4px',
            padding: '4px 8px',
            fontWeight: 'bold',
            textDecoration: 'none',
            lineHeight: '24px'
          }}
          href="https://www.divirod.com/privacy-policy-1"
          target="_blank"
          rel="noreferrer"
        >
          Privacy
        </a>
      </div>
    </div>
  );
}
